var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddressPinOutlineX2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3C7.85081 3 4.5 6.33659 4.5 10.4368C4.5 12.8572 5.7545 15.1126 7.36885 16.9981C8.97228 18.8708 10.8345 20.2653 11.8302 20.9455C11.9364 21.0182 12.0636 21.0182 12.1698 20.9455C13.1655 20.2653 15.0277 18.8708 16.6312 16.9981C18.2455 15.1126 19.5 12.8572 19.5 10.4368C19.5 6.33659 16.1492 3 12 3ZM2.5 10.4368C2.5 5.21797 6.76034 1 12 1C17.2397 1 21.5 5.21797 21.5 10.4368C21.5 13.5447 19.9032 16.2516 18.1504 18.2989C16.3866 20.3588 14.3659 21.8674 13.2981 22.5969C12.5115 23.1344 11.4885 23.1344 10.7019 22.5969C9.63412 21.8674 7.61336 20.3588 5.84963 18.2989C4.09681 16.2516 2.5 13.5447 2.5 10.4368Z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 10.5C14.5 11.8807 13.3807 13 12 13C10.6193 13 9.5 11.8807 9.5 10.5C9.5 9.11929 10.6193 8 12 8C13.3807 8 14.5 9.11929 14.5 10.5Z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddressPinOutlineX2);
export default __webpack_public_path__ + "static/media/AddressPinOutlineX2.457b57fddf5ffad02739cfdb8ec18a78.svg";
export { ForwardRef as ReactComponent };